<script lang="ts">
    
    import { Button, ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Icon, Table } from "sveltestrap";
    import type { OptionTemplate, QuestionOptionsObject } from "../global";
    import { v4 as uuidv4 } from 'uuid';
    import Watch from "./Watch.svelte";
    import { QuestionOption } from "../Model/QuestionOption";
    import StateInput from "./StateInput.svelte";
    import { optionsTemplates } from "../services/options-templates";
    import StateCheck from "./StateCheck.svelte";
    import { isOptionTemplate } from "../services/type-guards";

    export let options: QuestionOptionsObject;

    $: questionOptions = options.questionOptions;

    function addOption(): void {
        const option = new QuestionOption(uuidv4(), '', false, false, false);
        questionOptions.addOption(option);
    }

    function removeOption(option: QuestionOption): void {
        questionOptions.quitOption(option.id);
    }

    function moveUp({ id }: QuestionOption): void {
        questionOptions.moveUp(id);
    }

    function moveDown({ id }: QuestionOption): void {
        questionOptions.moveDown(id);
    }

    function applyTemplate(template: Array<OptionTemplate | string>): void {
        template.forEach(optionTpl => {
            let text: string;
            let isNA: boolean;

            if (isOptionTemplate(optionTpl)) {
                text = optionTpl.text;
                isNA = optionTpl.isNA;
            } else {
                text = optionTpl;
                isNA = false;
            }

            const option = new QuestionOption(uuidv4(), text, false, false, isNA);
            questionOptions.addOption(option);
        });
    }

    function deleteAllOptions(): void {
        if (!confirm('¿Seguro que desea eliminar todas las opciones?')) {
            return;
        }
        questionOptions.quitAll();
    }

</script>

<div class="d-flex justify-content-end gap-3">
    <Button type="button" color="danger" size="sm" on:click={deleteAllOptions}>
        Quitar todas
    </Button>
    <Dropdown>
        <DropdownToggle size="sm" color="primary" caret outline>Plantilla</DropdownToggle>
        <DropdownMenu end>
            {#each optionsTemplates as { name, options }}
            <DropdownItem on:click={() => applyTemplate(options)}>{name}</DropdownItem>
            {/each}
        </DropdownMenu>
    </Dropdown>
</div>

<Table>
    <thead>
        <tr>
            <th>#</th>
            <th>Texto</th>
            <th><span title="Seleccionar esta opción invalidará el formulario">Invalida</span></th>
            <th><span title="Seleccionar esta opción mostrará la subsección contenida en la pregunta">Subsección</span></th>
            <th><span title="La opción marca la pregunta como no aplica">N/A</span></th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <Watch store={questionOptions} let:value={options}>
            {#each options as option, index}
                <tr>
                    <td><strong>{index + 1}</strong></td>
                    <td>
                        <StateInput type="text" class="input-sm" store={option.text} />
                    </td>
                    <td>
                        <StateCheck store={option.restrict} />
                    </td>
                    <td>
                        <StateCheck store={option.unLock} />
                    </td>
                    <td>
                        <StateCheck store={option.isNA} />
                    </td>
                    <td class="text-end">
                        <ButtonGroup size="sm">
                            <Button type="button" color="primary" outline on:click={() => moveDown(option)}><Icon name="arrow-down" /></Button>
                            <Button type="button" color="primary" outline on:click={() => moveUp(option)}><Icon name="arrow-up" /></Button>
                            <Button type="button" color="danger" on:click={() => removeOption(option)}><Icon name="x" /></Button>
                        </ButtonGroup>
                    </td>
                </tr>
            {/each}
        </Watch>
    </tbody>
</Table>

<div class="text-end mt-3">
    <Button type="button" color="primary" size="sm" on:click={addOption}>
        <Icon name="plus" /> Añadir opción
    </Button>
</div>
